import React, { Component, type ErrorInfo, type ReactNode } from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.tsx';
import './index.css';
import './config/firebase';

class MarketingErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean }> {
  constructor(props: { children: ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('[MarketingErrorBoundary]', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <div className="p-6 text-center">Something went wrong. Please refresh the page.</div>;
    }
    return this.props.children;
  }
}

const container = document.getElementById('root')!;
const helmetContext = {};

const app = (
  <React.StrictMode>
    <MarketingErrorBoundary>
      <HelmetProvider context={helmetContext}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </MarketingErrorBoundary>
  </React.StrictMode>
);

if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
